import { CategoryNaturalKey } from '../documents/models/category';
import { UserActionName } from './user-action';

type DownloadActionsByCategory = {
    [key in CategoryNaturalKey]?: UserActionName;
};

const documentCategories: DownloadActionsByCategory = {
    'regulatory-documents': 'Download General Manuals - Regulatory Documents',
    'general-information': 'Download General Manuals - General Information',
    'quick-reference-guide': 'Download General Manuals - Quick Reference Guide',
    'general-communications': 'Download General Communications',
    'specimen-collection': 'Download General Training Materials - Specimen Collection',
    'packaging-and-shipping': 'Download General Training Materials - Packaging and Shipping',
    'application-training': 'Download Application Training',

    'result-alerts': 'Download Result Alerts',
    'lab-reports': 'Download Lab Results',
    'data-revisions': 'Download Data Revisions',
    'cancellation': 'Download Cancellations',

    'study-manuals': 'Download Lab Manuals - Study Manuals',
    'synopsis': 'Download Lab Manuals - Specimen Collection Guides',
    'lab-manuals-others': 'Download Lab Manuals - Others',

    'site-actions': 'Download Site Actions',
    'site-communications': 'Download Site Communications',
    'sponsor-communications-main': 'Download Sponsor Communications',
    'sponsor-communications-e-learning': 'Download Sponsor Communications',

    'training-materials-e-learning': 'Download Training Materials - eLearning',
    'training-materials-others': 'Download Training Materials - Others',
};

export const downloadActions = {
    documentCategories
};